(function(){
    'use strict'

    angular
    .module('app.inscripciones')
    .controller('inscripciones.Numeros', Numeros);

    Numeros.$inject = ['$scope','$animationsSrv', 'ApiBaseService', 'logger', '$location', 'UserInfoService', 'moment'];

    function Numeros($scope, $animationsSrv, ApiBaseService, logger, $location, UserInfoService, moment) {
    
        $animationsSrv.scrollToTop();

        //const ESTADO_CONFIRMADO = 2;

        var permisosInscripciones = UserInfoService.getPermisosInscripciones();
        var permisosNumeros = UserInfoService.getPermisosAsignarNumeros();
        var vm = this;

        vm.uiData = {
            puedeGuardar: permisosInscripciones.guardar === true,
            puedeModificar: permisosInscripciones.modificar === true,
            puedeEliminar: permisosInscripciones.eliminar === true,
            puedeVerBusqueda: permisosNumeros.ver === true,
            ordenarPor(){
                return 'nombre';
            },
        };

        vm.criteriosBusqueda = {
            eventoId: 0,
            estado: 0,
            usuarioId: 0,
            inscriptorId: 0,
            categoriaId: 0,
            nombre: '',
            apellidos: '',
            apellido2: ''
        };

        vm.displayLimits = [
            {
                id: 10,
                descripcion: '10 Registros'
            },
            {
                id: 20,
                descripcion: '20 Registros'
            },
            {
                id: 50,
                descripcion: '50 Registros'
            },
            {
                id: undefined,
                descripcion: 'Todos'
            },
        ];

        vm.displayLimit = vm.displayLimits[0].id;

        vm.collection = [];
        vm.collectionCopy = [];

        vm.eventos = [];
        vm.categorias = [];

        vm.title = 'Numeros';

        getComboData(vm.eventos, 'api/Eventos/All', null, 'Error al cargar los eventos');

        function getComboData(array, apiUrl, params, errorMessage){
            ApiBaseService.remoteController = apiUrl;
            var promise = ApiBaseService.getAll(params)
            .then(function(data){
                array.splice(0);
                array.push(...data);
            })
            .catch(function(error){
                $logger.error(errorMessage);
            }); 
            
            return promise;
        };

        function getRemoteController()
        {
            return 'api/Inscripciones/All';
        };

        vm.clearCriteria = function()
        {
            vm.criteriosBusqueda = {
                eventoId: 0,
                estado: 0,
                usuarioId: 0,
                inscriptorId: 0,
                categoriaId: 0,
                nombre: '',
                apellidos: '',
                apellido2: ''
            };
        };

        //getAll();

        vm.getAll = function()
        {
            getAll();
        };

        function doFormValidations()
        {
            validateSelectProperty($scope.dataForm, vm.criteriosBusqueda, 'eventoId' );
        };

        function getAll(){

            $scope.submitted = true;

            doFormValidations();

            if($scope.dataForm.$valid){

                ApiBaseService.remoteController = getRemoteController();

                const criterios = [
                    vm.criteriosBusqueda.eventoId,
                    vm.criteriosBusqueda.estado,
                    vm.criteriosBusqueda.inscriptorId,
                    vm.criteriosBusqueda.categoriaId,
                    vm.criteriosBusqueda.nombre === '' ? '0' : vm.criteriosBusqueda.nombre,
                    vm.criteriosBusqueda.apellidos === '' ? '0' : vm.criteriosBusqueda.apellidos,
                    vm.criteriosBusqueda.apellido2 === '' ? '0' : vm.criteriosBusqueda.apellidos2
                ];
    
                var promise = ApiBaseService.getAll(criterios);
    
                promise
                .then(function(collection){
    
                    collection.forEach((element)=>{
                        element.fullName = `${element.nombre} ${element.apellidos} ${element.apellido2}`;
                    });
    
                    vm.collection = collection;
                    vm.collectionCopy = [...vm.collection];
                })
                .catch(function(error){
                    switch (error.status) {
                        case 401:
                            logger.error('La sessión ha terminado.');
                            break;
                    
                        default:
                            logger.error('Error al obtener los datos.');
                            break;
                    }
                });

            }

        };

        vm.save = function(item)
        {
            vm.update(item);
        };

        vm.update = function(data){
            ApiBaseService.remoteController = 'api/Inscripciones/AsignarNumero';
            var promise = ApiBaseService.update(data);
            
            promise
            .then(function(response){
                vm.collectionCopy.forEach(function(element) {
                    if(element.id === data.id)
                    {
                        element.numero = response.data.object.numero; 
                        element.numeroRegistrado = response.data.object.numeroRegistrado;                      
                    }
                });
                data.numeroRegistrado = response.data.object.numeroRegistrado;
                logger.success('Registro modificado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar el Registro');
                        break;
                }
                
            });   
        };

        vm.onTextChanged = function(property){
            switch (property) {
                case "nombre":
                    onNombreChanged(property);
                    break;
                default:
                    break;
            }
        };

        function onNombreChanged(property)
        {

            vm.collection = [...vm.collectionCopy];

            if(vm.criteriosBusqueda.nombre && vm.criteriosBusqueda.nombre.trim() != '')
            {
                vm.collection = vm.collection.filter(function(c) {
                    return c.fullName.toLowerCase().includes(vm.criteriosBusqueda.nombre.toLowerCase().trim());
                });               
            }
        };

        function validateSelectProperty(form, object, property){
            if(object[property] == 0){
                form[property].$setValidity("different", false);
                return false;
            }
            else{
                form[property].$setValidity("different", true);
                return true;
            }
        };

        vm.onSelectChanged = function(property){

            switch (property) {
                case "eventoId":
                    onEventoIdChanged(property);
                    break;
                default:
                    break;
            }
        };

        function onEventoIdChanged(property)
        {
            const result = validateSelectProperty($scope.dataForm, vm.criteriosBusqueda, property );

            vm.criteriosBusqueda.categoriaId = 0;
            vm.categorias = [];

            if(result)
            {
                getComboData(vm.categorias, 'api/EventosCategorias', [vm.criteriosBusqueda.eventoId], 'Error al cargar las Categorias');
            }
        };

    }
})();